
import { supabase } from '@/integrations/supabase/client';

/**
 * Track a menu view for analytics purposes
 * @param menuId - The ID of the menu being viewed
 * @param restaurantId - The ID of the restaurant the menu belongs to
 */
export async function trackMenuView(menuId: string, restaurantId: string): Promise<void> {
  if (!menuId || !restaurantId) {
    return;
  }

  const today = new Date().toISOString().split('T')[0];
  
  try {
    await supabase.rpc('increment_menu_view', {
      p_menu_id: menuId,
      p_restaurant_id: restaurantId,
      p_date: today
    });
  } catch (error) {
    // Silent error handling
  }
}

/**
 * Track a phone call click for analytics purposes
 * @param restaurantId - The ID of the restaurant being called
 */
export async function trackPhoneCall(restaurantId: string): Promise<void> {
  if (!restaurantId) {
    return;
  }

  const today = new Date().toISOString().split('T')[0];
  
  try {
    await supabase.rpc('increment_menu_view', {
      p_menu_id: 'phone-call',
      p_restaurant_id: restaurantId,
      p_date: today
    });
  } catch (error) {
    // Silent error handling
  }
}
